import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/authTypes';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { loading, checkAuthAndLogout } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check both user existence and token validity
  const isAuthenticated = checkAuthAndLogout();
  if (!isAuthenticated) {
    // Redirect to the login page but save the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
} 